export default function PHP_require() {
  return (
    <div>
      <h1>PHP_require</h1>
    </div>
  );
}
